import styled from 'styled-components';

export const PageLoadingRegion = styled.div`
    display: flex;
    min-height: 12rem;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const ChunkLoadFailureRegion = styled.div`
    display: flex;
    min-height: 12rem;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-3, 0.75rem);
    padding: 0 var(--space-6, 1.5rem);
    text-align: center;
`;

export const ChunkLoadFailureTitle = styled.h2`
    font-size: var(--font-size-base, 1rem);
    font-weight: var(--font-weight-semibold, 600);
`;

export const ChunkLoadFailureMessage = styled.p`
    color: var(--color-muted-foreground);
    font-size: var(--font-size-sm, 0.875rem);
`;

export const VisuallyHiddenText = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;
